import { render, staticRenderFns } from "./PECARNAlgorithm.vue?vue&type=template&id=50b1a1cd&scoped=true"
import script from "./PECARNAlgorithm.vue?vue&type=script&lang=js"
export * from "./PECARNAlgorithm.vue?vue&type=script&lang=js"
import style0 from "./PECARNAlgorithm.vue?vue&type=style&index=0&id=50b1a1cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b1a1cd",
  null
  
)

export default component.exports